import React from 'react'
import { LanguageProvider } from './Context/LanguageContext';
import App from './App';

const AppWrapper = () => {
    return ( 
        <LanguageProvider>
            <App/>
        </LanguageProvider>
    );
}
 
export default AppWrapper;